import React, { useState } from 'react'
import { useMediaQuery } from '@material-ui/core'
import { SkySwitch } from '../../../Core/Switch/SkySwitch'
import FlexView from 'react-flexview/lib'
import { PolicyUpdates } from '../PolicyUpdates/PolicyUpdates'
import { isMobile } from 'react-device-detect'
import { isUK } from '../../../../services/utils'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { PolicyManagementContextStore } from '../../../../context/PolicyManagementContext'
import { useParams } from 'react-router-dom'
import { Action } from '../../../../models/Action'
import { SUBSCRIPTION_STATE } from '../../../../models/insurance-models/PolicySubscriptionState'
import { ACTIONS } from '../../../../context/PolicyLiabilityExtensionContext'
import {
    PolicyRenewalContextStore,
    RENEWAL_ACTIONS,
} from '../../../../context/PolicyRenewalContext'
import { ModifyPolicyOld } from '../ModifyPolicyOld'
import { ModifyPolicyButton } from '../ModifyPolicy/ModifyPolicyButton'
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog'
import { ElevatedCircle } from '../../../Core/ElevatedCircle'
import { ReactComponent as LiabilityShield } from '../../../../assets/liability_shield.svg'
import { ReactComponent as StrokeIcon } from '../../../../assets/stroke-3.svg'
import DataLayerService from '../../../../services/DataLayerService'
import { SessionService } from '../../../../services/SessionService'

var classNames = require('classnames')

export const YourPolicyDetailsSection = () => {
    const myPoliciesContext = React.useContext(PolicyManagementContextStore)
    const policyRenewalContext = React.useContext(PolicyRenewalContextStore)
    const isMobileByWidth = !useMediaQuery((theme) =>
        theme.breakpoints.up('md')
    )

    const toggleCurrentRenewalSwitch = async (selected) => {
        
        if (policyRenewalContext.insuranceSubscriptionState != selected.title){
            policyRenewalContext.dispatch({ type: RENEWAL_ACTIONS.TOGGLE_SUBS_STATE });
        }
    }

    let { insuranceId } = useParams()

    const [open, setOpen] = useState(false)

    const openDialog = () => {
        DataLayerService.pushToDataLayer({
            event: 'policy-update-button-clicked',
        })
        setOpen(true)
    }

    const closeDialog = () => {
        setOpen(false)
    }
    let insurance: ActiveInsuranceModel = myPoliciesContext.all_policies.find(
        (pol: ActiveInsuranceModel) => pol.insuranceId == insuranceId
    )
    

    const skySwitchKeys = [
        {
            title: SUBSCRIPTION_STATE.CURRENT,
            selected:
                policyRenewalContext.insuranceSubscriptionState ==
                SUBSCRIPTION_STATE.CURRENT,
        },
        {
            title: SUBSCRIPTION_STATE.RENEWAL,
            selected:
                policyRenewalContext.insuranceSubscriptionState ==
                SUBSCRIPTION_STATE.RENEWAL,
        },
    ]

    if (isMobile)
    {
        return !isUK() &&
            insurance.isActiveOrSchedule() &&
            insurance.isSubscription() ? (
            <>
            {(insurance.isActive() && (insurance.insuranceType === 'Annual' ||  insurance.insuranceType === 'Monthly')) &&<ModifyPolicyButton insurance={insurance}/>}
            {(insurance.autoRenew ===true) && (
                            <SkySwitch
                                onSelect={toggleCurrentRenewalSwitch}
                                keys={skySwitchKeys}
                            />
                        )}
            </>
        ) : (
            <div />
        )
    }
        
    else
        return (
            <FlexView
                column={isMobileByWidth}
                className="space-between margin-bottom-basic"
            >
                <div
                    className={classNames({
                        'margin-bottom-basic': isMobileByWidth,
                    })}
                >
                    <div className="text-title bold black">
                        Your policy{' '}
                        {policyRenewalContext.insuranceSubscriptionState ==
                        SUBSCRIPTION_STATE.CURRENT
                            ? 'details'
                            : 'renewal'}
                    </div>
                    {/* <PolicyUpdates /> */}
                </div>
                <div>
                    {(insurance.isActive() && (insurance.insuranceType === 'Annual' ||  insurance.insuranceType === 'Monthly')) && <ModifyPolicyButton insurance={insurance}/>}
                    {!isUK() && 
                        insurance.isActiveOrSchedule() &&
                        insurance.isSubscription() && (insurance.autoRenew ===true) && (
                            <SkySwitch
                                onSelect={toggleCurrentRenewalSwitch}
                                keys={skySwitchKeys}
                            />
                        )}
                </div>
            </FlexView>
        )
}
